export default "assets/images/icons/facebook-3e3ce97c.svg";